<script setup>
import { defineProps } from "vue"
import { useRoute } from "vue-router"
const route = useRoute()
const props = defineProps({ title: { required: true, type: String } })
</script>
<template>
  <nav class="flex mb-5" aria-label="Breadcrumb">
    <ol role="list" class="flex items-center space-x-2">
      <li>
        <router-link
          to="/"
          class="text-sm font-medium text-gray-500 hover:text-gray-700"
          >{{ $t("help.side-bar.bread-crumb.home") }}</router-link
        >
      </li>
      <li>
        <svg
          class="h-5 w-5 flex-shrink-0 text-gray-300"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
        </svg>
      </li>
      <li>
        <router-link
          :to="{ name: 'HelpHome' }"
          class="text-sm font-medium text-gray-500 hover:text-gray-700"
          >{{ $t("help.side-bar.bread-crumb.help") }}</router-link
        >
      </li>
      <li>
        <svg
          class="h-5 w-5 flex-shrink-0 text-gray-300"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
        </svg>
      </li>
      <li>
        <router-link
          v-if="route.path.startsWith('/help/guides/installers')"
          :to="{ name: 'HelpInstaller' }"
          class="text-sm font-medium text-gray-500 hover:text-gray-700"
          >{{ $t("help.home.installer") }}</router-link
        >
        <router-link
          v-else
          :to="{ name: 'HelpHouseholder' }"
          class="text-sm font-medium text-gray-500 hover:text-gray-700"
          >{{ $t("help.home.householder") }}</router-link
        >
      </li>
      <li>
        <svg
          class="h-5 w-5 flex-shrink-0 text-gray-300"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
        </svg>
      </li>
      <li>
        <a
          class="text-sm font-medium text-gray-500 hover:text-gray-700"
          aria-current="page"
        >
          {{ title }}
        </a>
      </li>
    </ol>
  </nav>
</template>
